module.exports = __webpack_public_path__ + "img/autospin_btn.1853caad.png";